module.exports = __webpack_public_path__ + "img/logo.e09926b9.svg";